import { render } from "./LessonCard.vue?vue&type=template&id=22c1bfbf&scoped=true"
import script from "./LessonCard.vue?vue&type=script&lang=js"
export * from "./LessonCard.vue?vue&type=script&lang=js"

import "./LessonCard.vue?vue&type=style&index=0&id=22c1bfbf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22c1bfbf"]])

export default __exports__